import Page from "../Page";
import Profile from "./Profile/Profile";
import Billing from "./Billing/Billing";
import Generation from "./Generation/Generation";
import Team from "./Team/Team";
import { useNavigate, useParams } from "react-router-dom";
import urls from "../../routes";
import Tabs from "../../ui/Tabs/Tabs";
import styles from "./Settings.module.scss";
import NotFound from "../NotFound/NotFound";
import toSentenceCase from "../../util/toSentenceCase";
import Keywords from "./Keywords/Keywords";

function Settings() {
  const navigate = useNavigate();
  const { tabValue, subTabValue } = useParams();

  const settingsTabs = [
    {
      id: "generation",
      label: "Generation",
      content: <Generation />,
    },
    {
      id: "team",
      label: "Team",
      content: <Team />,
    },
    {
      id: "profile",
      label: "Profile",
      content: <Profile />,
    },
    {
      id: "keywords",
      label: "Keywords",
      content: <Keywords />,
    },
    {
      id: "billing",
      label: "Billing & Usage",
      content: <Billing />,
    },
  ];

  if (!tabValue || !settingsTabs.map((tab) => tab.id).includes(tabValue)) {
    return <NotFound />;
  }

  return (
    <Page
      title="Settings"
      documentTitle={`${toSentenceCase(tabValue)} Settings`}
      fullHeight={
        !["billing", "generation", "team", "profile", "keywords"].includes(
          tabValue,
        ) ||
        (!!subTabValue &&
          ["audiences", "features-services", "goal-pages"].includes(
            subTabValue,
          ))
      }
    >
      <Tabs
        className={styles.container}
        defaultValue="team"
        value={tabValue}
        onValueChange={(value) => navigate(`${urls.settings.root}/${value}`)}
        tabs={settingsTabs}
      />
    </Page>
  );
}

export default Settings;
